<div class="d-flex align-items-center">
  <span
    *ngIf="params.data?.playerHealth === 'Green'"
    class="health-indicator health-green mr-2"
    nz-tooltip
    [nzTooltipTitle]="getHealthTooltip(params.data, 'Healthy')"
  >
    <span nz-icon nzType="check-circle" nzTheme="fill"></span>
  </span>
  <span
    *ngIf="params.data?.playerHealth === 'Yellow'"
    class="health-indicator health-yellow mr-2"
    nz-tooltip
    [nzTooltipTitle]="getHealthTooltip(params.data, 'Watch List')"
  >
    <span nz-icon nzType="info-circle" nzTheme="fill"></span>
  </span>
  <span
    *ngIf="params.data?.playerHealth === 'Red'"
    class="health-indicator health-red mr-2"
    nz-tooltip
    [nzTooltipTitle]="getHealthTooltip(params.data, 'Unhealthy')"
  >
    <span nz-icon nzType="exclamation-circle" nzTheme="fill"></span>
  </span>
  <span
    *ngIf="params.data?.playerHealth === 'Grey'"
    class="health-indicator health-grey mr-2"
    nz-tooltip
    [nzTooltipTitle]="getHealthTooltip(params.data, 'Not Available')"
  >
    <span nz-icon nzType="minus-circle" nzTheme="outline"></span>
  </span>
  <span *ngIf="params.data?.playerHealth === 'Green'">Vitals look good</span>
  <span *ngIf="params.data?.playerHealth === 'Yellow'"
    >Performance may be impacted</span
  >
  <span *ngIf="params.data?.playerHealth === 'Red'">Performance likely impacted</span>
  <span *ngIf="params.data?.playerHealth === 'Grey'"
    >One or more health metrics are not available</span
  >
  <span *ngIf="params.data?.playerHealth == null">-</span>
</div>
